import Tag from 'src/components/DataDisplay/Tag/Tag'

export interface SelectedFilter {
  key: string
  label: string
  value: string
}

export const SelectedFiltersBar = ({
  selectedFilters = [],
  onRemoveFilter,
}: {
  selectedFilters: SelectedFilter[]
  onRemoveFilter: (filter: SelectedFilter) => void
}) => {
  return (
    <div className="flex min-w-0 flex-1 flex-row items-center gap-2 overflow-auto">
      {selectedFilters?.map((filter) => {
        return (
          <Tag
            key={`${filter.key}-${filter.value}`}
            onClose={() => onRemoveFilter(filter)}
          >
            {filter.label}
          </Tag>
        )
      })}
    </div>
  )
}

export default SelectedFiltersBar
